import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { CommsStatusService } from '../api/comms-status.service';
import { BRAND } from '../../branding/brand.config';

@Component({
  selector: 'app-comms-blocked-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule],
  template: `
    <mat-dialog-content>
      <div class="blocked-content">
        <mat-icon class="blocked-icon">signal_wifi_off</mat-icon>
        <p class="blocked-message">
          {{ brand.commsBlockedMessage }}
          Press <strong>Continue</strong> to resume operation.
        </p>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-flat-button color="primary" (click)="onContinue()">Continue</button>
    </mat-dialog-actions>
  `,
  styles: [`
    .blocked-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 16px;
      padding: 8px 0 4px;
    }
    .blocked-icon {
      font-size: 48px;
      width: 48px;
      height: 48px;
      color: var(--mat-sys-error, #f44336);
    }
    .blocked-message {
      font-size: 0.95rem;
      line-height: 1.6;
      text-align: center;
      max-width: 320px;
      margin: 0;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommsBlockedDialogComponent {
  protected readonly brand = BRAND;
  private readonly commsStatus = inject(CommsStatusService);
  private readonly dialogRef = inject(MatDialogRef<CommsBlockedDialogComponent>);

  protected onContinue(): void {
    this.commsStatus.resume();
    this.dialogRef.close();
  }
}
